import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import DropDownIcon from "../../../../assets/DropDownIcon";
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';

import ContactAvatar from "../../../../components/ContactAvatar";
import Translate from '../../../../components/Translate';
import {userLogoutRequest} from '../../../../services/user/action';
import UserProfile from './UserProfile';
import LogoutIcon from "../../../../assets/images/logout.png";
import ProfileIcon from "../../../../assets/images/profile.png";
import config from "../../../../config";
import {logOperatorSession} from "../../../../services/user/api";

const styles = {
    button: {
        padding: '20px',
        height: '40px',
        width: 'fit-content'
    },
    menuItem: {
        minWidth: '150px',
        height: '15px',
    },
    avatar: {
        width: '30px',
        height: '30px',
    },
    spacer: {
        width: '8px',
        height: '1px',
    },
    modalStyle: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '20px',
            border: 'none',
            padding: 'none',
        },
    }
};

class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            settingsModalIsOpen: false,
            integrationsModalIsOpen: false,
        };
    }

    handleToggle = () => {
        this.setState(state => ({isOpen: !state.isOpen}));
    };

    handleClose = (event) => {
        if (this.anchorEl.contains(event.target)) {
            return;
        }

        this.setState({isOpen: false});
    };

    closeModal = modalName => () => {
        this.setState({[modalName]: false});
    };

    openModal = modalName => () => {
        this.setState({
            [modalName]: true,
            isOpen: false,
        });
    };

    render() {
        const {isOpen, settingsModalIsOpen} = this.state;
        let inMenu = true;
        const {
            classes, logoutUser, user
        } = this.props;

        const contact = {
            firstName: user.firstName,
            lastName: user.lastName,
            thumbUrl: user.thumbUrl,
        };

        return (
            <div onClick={() => inMenu = true}
                 style={{background: '#f1f1f1', borderRadius: '7px'}}>
                <Button
                    id="header-avatar-icon-button"
                    buttonRef={(node) => {
                        this.anchorEl = node;
                    }}
                    aria-owns={isOpen ? 'user-menu-list-grow' : null}
                    aria-haspopup="true"
                    onClick={this.handleToggle}
                    className={classes.button}
                >
                        <ContactAvatar contact={contact} customClass={classes.avatar} inMenu={inMenu}/>
                        <div className={classes.spacer}/>
                        <div style={{marginRight: '-5px'}}>
                            <span style={{marginRight: '5px'}}>{user.firstName}</span>
                            <span style={{marginRight: '10px'}}>{user.lastName}</span>
                            <p></p>
                            <span style={{color: 'gray', fontSize: '10px'}}>{user.authorities[0].split('_')[1]}</span>
                        </div>
                        <DropDownIcon width="8" hight="4"/>
                    </Button>

                <Popper open={isOpen} anchorEl={this.anchorEl} transition disablePortal placement="bottom-end">
                    {({TransitionProps}) => (
                        <Grow
                            {...TransitionProps}
                            id="user-menu-list-grow"
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <MenuList role="menu">
                                        <MenuItem
                                            id="header-profile-settings"
                                            className={classes.menuItem}
                                            onClick={this.openModal('settingsModalIsOpen')}
                                        >
                                            <img style={{marginRight: '10px'}} src={ProfileIcon} width={'18'}
                                                 height={'18'}/>
                                            <Translate text="profile"/>
                                        </MenuItem>
                                        <MenuItem
                                            id="header-logout"
                                            className={classes.menuItem}
                                            onClick={async (event) => {
                                                try {
                                                    await logOperatorSession({
                                                        operatorPlatformId: user.id,
                                                        parentCompanyId: user.companyId,
                                                        actionType: 'LOGOUT',
                                                        userAgent: navigator.userAgent,
                                                    });
                                                } catch (e) {
                                                    console.error("Logging logout failed", e);
                                                }
                                                logoutUser();
                                                this.handleClose(event);
                                            }
                                            }
                                        >
                                            <img style={{marginRight: '10px'}} src={LogoutIcon} width={'18'}
                                                 height={'18'}/>
                                            <Translate text="logOut"/>
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
                <Modal
                    closeTimeoutMS={config.closeTimeoutMS}
                    isOpen={settingsModalIsOpen}
                    style={styles.modalStyle}
                    onRequestClose={this.closeModal('settingsModalIsOpen')}
                >
                    <UserProfile close={this.closeModal('settingsModalIsOpen')} isOpen={settingsModalIsOpen}/>
                </Modal>
            </div>
        );
    }
}

UserMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    logoutUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    logoutUser: () => {
        dispatch(userLogoutRequest());
    },
});

export default withStyles(styles)(connect(null, mapDispatchToProps)(UserMenu));



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/UserMenu.jsx